import React, { useRef, useState } from 'react';
import styles from './Tasks.module.scss';
import clsx from 'clsx';
import ModalTask from '../ModalTask/ModalTask';
import { useDispatch } from 'react-redux';
import { setModalTask } from '../../redux/slices/app.slice';
import { SERVICES_CONTENT } from '../../constants/marketingContent';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import { trackGoal } from '../../analytics/metrika';
import { CodeIcon, TelegramLogoIcon, MonitorIcon, WrenchIcon, DatabaseIcon, LayoutIcon } from '@phosphor-icons/react';
gsap.registerPlugin(Flip);

const Tasks = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeHeadHeight, setActiveHeadHeight] = useState(100);
  const dispatch = useDispatch();
  const services = SERVICES_CONTENT.items;
  const container = useRef(null);
  const headers = useRef([]);
  const placeholders = useRef([]);
  const { contextSafe } = useGSAP({ scope: container });

  const animateTaskHeader = contextSafe((index, openModal, onDone) => {
    const header = headers.current[index];
    const placeholder = placeholders.current[index];

    if (!header) return;

    const state = Flip.getState(header);
    const currentHeight = header.offsetHeight;
    const currentWidth = header.offsetWidth;
    const isMobile = window.matchMedia('(max-width: 900px)').matches;

    if (openModal) {
      setActiveHeadHeight(currentHeight);
      if (placeholder) {
        placeholder.style.height = `${currentHeight}px`;
      }
      header.classList.add('fixed-item');
      if (!isMobile) {
        // Keep header width locked to card width on desktop.
        header.style.width = `${currentWidth}px`;
      }
    } else {
      if (placeholder) {
        placeholder.style.height = '0px';
      }
      header.classList.remove('fixed-item');
    }

    Flip.from(state, {
      duration: 0.3,
      ease: 'power3.out',
      scale: true,
      onComplete: () => {
        if (!openModal || isMobile) {
          header.style.width = '';
        }
        if (onDone) {
          onDone();
        }
      },
    });
  });

  const openTaskModal = (index) => {
    const service = services[index];

    trackGoal('service_open', {
      serviceId: service?.id || 'unknown',
      serviceName: service?.name || 'unknown',
    });

    setActiveIndex(index);
    dispatch(setModalTask(true));
    animateTaskHeader(index, true);
  };

  const closeTaskModal = () => {
    dispatch(setModalTask(false));

    if (activeIndex === null) return;

    animateTaskHeader(activeIndex, false, () => {
      setActiveIndex(null);
    });
  };
  const getTaskIcon = (name) => {
    const sizeIcon = '65%';
    const colorIcon = '#ff3b52';
    switch (name) {
      case 'browser':
        return <CodeIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
      case 'layout':
        return <LayoutIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
      case 'telegram':
        return <TelegramLogoIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
      case 'frontend':
        return <MonitorIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
      case 'wordpress':
        return <WrenchIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
      case 'backend':
        return <DatabaseIcon size={sizeIcon} weight="duotone" color={colorIcon} />;
    }
  };
  return (
    <>
      <section className={clsx(styles.wrap)} id="tasks" ref={container}>
        <div className="container">
          <div className={clsx(styles.inner)}>
            <div className={clsx(styles.title, 'title')}>{SERVICES_CONTENT.title}</div>

            <div className={clsx(styles.list)}>
              {services.map((item, index) => (
                <div
                  className={clsx(styles.item)}
                  key={item.id}
                  // style={{
                  //   '--task-hover-shadow': item.hoverShadow,
                  // }}
                  onClick={() => {
                    openTaskModal(index);
                  }}>
                  <div className={clsx(styles.body)}>
                    <div
                      className={clsx(styles.headPlaceholder)}
                      ref={(el) => {
                        placeholders.current[index] = el;
                      }}
                    />
                    <div
                      className={clsx(styles.head)}
                      ref={(el) => {
                        headers.current[index] = el;
                      }}>
                      <div className={clsx(styles.box)}>
                        <div className={clsx(styles.name)}>{item.name}</div>
                      </div>
                      <div className={clsx(styles.image)}> {getTaskIcon(item.icon)}</div>

                      {/* <img className={clsx(styles.image)} src={item.icon} alt={item.name} /> */}
                    </div>
                    <div className={clsx(styles.more)}>{SERVICES_CONTENT.cardCta}</div>
                    <div className={clsx(styles.text)}>{item.shortDesc}</div>
                    <div className={clsx(styles.meta)}>
                      <span>{item.timeline}</span>
                      <span className={clsx(styles.metaPrice)}>{item.priceRange}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <ModalTask
          activeTask={services[activeIndex]}
          headHeight={activeHeadHeight}
          onClose={() => {
            closeTaskModal();
          }}
        />
      </section>
    </>
  );
};

export default Tasks;
